<template>
  <div class="account-nav">
    <ul class="account-nav__list">
      <li
        v-for="(tier1) of navigation.items"
        :key="tier1.handle"
        class="account-nav__item"
      >
        <a
          class="account-nav__link text-body-m-regular"
          :href="tier1.url"
          v-html="tier1.title"
        />
      </li>
    </ul>
  </div>
</template>

<script>

/**
 * Vue: Account nav (account-nav)
 * -----------------------------------------------------------------------------
 * Account menu that appears for logged in users.
 * @param {Object} navigation - Account nav linklist from settings.
 *
 */
export default {
  name: 'AccountNav',

  props: {
    navigation: {
      type: Object,
      default: () => ({
        handle: '',
        items: [],
      }),
    },
  },

  data() {
    return {
      cnvsGlobal: true,
    }
  },
}
</script>
